import { NgIf, NgForOf, AsyncPipe, NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';

export const CommonDirectives = [
  NgIf,
  NgForOf,
  NgClass,
  AsyncPipe,
  NgStyle,
  NgTemplateOutlet
];